import React from "react";
import "./Self_Service_Center.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Self_Service_Banner from "./Self_Service_Banner/Self_Service_Banner";
import Self_Service_tabs from "./Self_Service_tabs/Self_Service_tabs";

function Self_Service_Center() {
  return (
    <>
      <section className="Self_Service_Center">
        <Common_white_header headingText={"Self Service Center"} />
        <div className="container">
          <Self_Service_Banner />
          <Self_Service_tabs/>
        </div>
      </section>
    </>
  );
}

export default Self_Service_Center;
